import { LogOut, Settings } from 'lucide-react';
import { Logo } from '../../components/Logo';

interface EncabezadoSesionProps {
  usuarioNombre: string | null;
  cajoneraAbierta: boolean;
  onAlternarCajonera: () => void;
  onSalir: () => void;
}

/**
 * Encabezado de la entrevista (especificación §4.4–§4.8): logo a la
 * izquierda, nombre de la aplicación, y a la derecha el nombre del usuario,
 * configuración y salir.
 */
export function EncabezadoSesion({
  usuarioNombre,
  cajoneraAbierta,
  onAlternarCajonera,
  onSalir,
}: EncabezadoSesionProps) {
  return (
    <header className="flex items-center gap-3 border-b border-slate-200 bg-white px-4 py-2 sm:px-6">
      <Logo />
      <span className="hidden min-w-0 truncate text-sm font-semibold text-slate-800 sm:inline">
        Paciente simulado estandarizado
      </span>
      <div className="ml-auto flex min-w-0 items-center gap-1">
        <span className="mr-2 min-w-0 truncate text-sm text-slate-600">{usuarioNombre ?? ''}</span>
        <button
          type="button"
          onClick={onAlternarCajonera}
          aria-expanded={cajoneraAbierta}
          aria-controls="cajonera-sesion"
          aria-label="Configuración"
          title="Configuración"
          className="rounded-lg p-2 text-slate-600 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
        >
          <Settings size={18} />
        </button>
        <button
          type="button"
          onClick={onSalir}
          className="inline-flex items-center gap-1 rounded-lg px-2 py-2 text-sm text-slate-600 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
        >
          <LogOut size={16} />
          <span className="hidden sm:inline">Salir</span>
        </button>
      </div>
    </header>
  );
}
